"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAddressBeaconError = void 0;
const __1 = require("..");
class NoAddressBeaconError extends __1.BeaconError {
    constructor() {
        super(__1.BeaconErrorType.NO_ADDRESS_ERROR, 'The wallet does not have an account set up. Please make sure to set up your wallet and try again.');
        this.name = 'NoAddressBeaconError';
        this.title = 'No Address';
    }
}
exports.NoAddressBeaconError = NoAddressBeaconError;
//# sourceMappingURL=NoAddressBeaconError.js.map